/**
 * Build a schema.org Service node from a PageTeasers container.
 *
 * Gated on `serviceType`: when it is unset the container is a plain teaser
 * grid and no structured data is emitted. Only teaser cards flagged
 * `isService` (and carrying a heading, used as the sub-service name) become
 * OfferCatalog entries; when none qualify the whole node is skipped so we
 * never emit an empty catalog.
 */
const buildServiceSchema = (id, serviceType, catalogName, teasers = []) => {
  if (!serviceType) return null

  const services = teasers.filter(
    (teaser) => teaser.isService && teaser.heading
  )
  if (services.length === 0) return null

  return {
    "@context": "https://schema.org",
    "@type": "Service",
    serviceType: serviceType,
    provider:  id ? { "@id": id } : undefined,
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: catalogName,
      itemListElement: services.map((service) => ({
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: service.heading,
        },
      })),
    },
  }
}

export default buildServiceSchema
